// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-08-28",
  "topic": "德州扑克新手避坑 / 德州扑克胜率基础 / 德州扑克下注顺序",
  "metaKeywords": "德州扑克新手避坑, 德州扑克胜率基础, 德州扑克下注顺序, 德州扑克同花顺规则, 德州扑克入门技巧, 德州扑克教学, hhpoker规则, hhpoker新手教程, 德州扑克新手规则, 德州扑克入门教程",
  "focusKeywords": [
    {
      "keyword": "德州扑克新手避坑",
      "path": "/guide",
      "anchorText": "德州扑克新手避坑教程"
    },
    {
      "keyword": "德州扑克胜率基础",
      "path": "/guide",
      "anchorText": "德州扑克胜率基础"
    },
    {
      "keyword": "德州扑克下注顺序",
      "path": "/guide",
      "anchorText": "德州扑克下注顺序入口"
    },
    {
      "keyword": "德州扑克同花顺规则",
      "path": "/guide",
      "anchorText": "德州扑克同花顺规则攻略"
    },
    {
      "keyword": "德州扑克入门技巧",
      "path": "/guide",
      "anchorText": "德州扑克入门技巧"
    },
    {
      "keyword": "德州扑克教学",
      "path": "/guide",
      "anchorText": "德州扑克教学入口"
    },
    {
      "keyword": "hhpoker规则",
      "path": "/guide",
      "anchorText": "hhpoker规则攻略"
    },
    {
      "keyword": "hhpoker新手教程",
      "path": "/guide",
      "anchorText": "hhpoker新手教程"
    },
    {
      "keyword": "德州扑克新手规则",
      "path": "/guide",
      "anchorText": "德州扑克新手规则详解"
    },
    {
      "keyword": "德州扑克入门教程",
      "path": "/guide",
      "anchorText": "德州扑克入门教程攻略"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克新手避坑怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克胜率基础怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议通过本站专题页查看最新图文步骤，再结合自身设备和版本操作，遇到问题可通过客服渠道提交截图快速处理。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克下注顺序怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议通过本站专题页查看最新图文步骤，再结合自身设备和版本操作，遇到问题可通过客服渠道提交截图快速处理。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克同花顺规则怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    }
  ]
};

export default dailySeoContent;
